/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Announcement = (props: IconProps) => (
  <Icon {...props}>
    <path d="M22 2H2V22L6 18H22V2ZM13 11H11V5H13V11ZM13 15H11V13H13V15Z" />
  </Icon>
);
